module.exports = "https://static.wanderu.com/ui-react/_next/static/media/spinner.687f2a08.svg";